import {qspost} from '@/plugins/axios'

/*
 * 注册基本信息提交
 * @constructor jack
 * */
export const submitInfo = (
    company_name, company_code, register_address_city, register_address_county, register_address_detail, post_address_city,
    post_address_county, post_address_detail, company_type_id, company_level_id, apply_time, is_new, member_type,
    member_type_detail_id, special_job, legal_person_name, legal_person_tel, tel_name, tel_number, tel_email,
    introducer, introducer_level_id, company_desc, business_range, achievement_desc, business_license,
    member_commitment, other_file,register_address_file,change_file, state, capital, renew = 0
) => qspost('/api/information/addInformation', {
    company_name,
    company_code,
    register_address_city,
    register_address_county,
    register_address_detail,
    post_address_city,
    post_address_county,
    post_address_detail,
    company_type_id,
    company_level_id,
    apply_time,
    is_new,
    member_type,
    member_type_detail_id,
    special_job,
    legal_person_name,
    legal_person_tel,
    tel_name,
    tel_number,
    tel_email,
    introducer,
    introducer_level_id,
    company_desc,
    business_range,
    achievement_desc,
    business_license,
    member_commitment,
    other_file,
    register_address_file,
    change_file,
    state,
    capital,
    renew
})


/*
 * 营业执照识别
 * @constructor jack
 * */
export const getDistinguish = (img) => qspost('/api/Distinguish/getDistinguish', {img})


/*
 * 注册基本信息获取
 * @constructor jack
 * */
export const getInformation = (id) => qspost('/api/information/getInformation', {id})


/*
 * 注册基本信息获取
 * @constructor jack
 * */
export const getInformation_update = (id) => qspost('/api/information/getInformation_update', {id})


/*
 * 会员证书获取
 * @constructor jack
 * */
export const certDetail = (user_id) => qspost('/api/cert/cert_detail', {user_id})
/*
 * 会员证书打印
 * @constructor jack
 * */
export const certPrint = (user_id) => qspost('/api/cert/print_cert', {user_id})

/*
 * 获取快递单号
 * @constructor jack
 * */
export const getExpressNumbers = (id) => qspost('/api/Manage/getExpressNumbers', {id})


/*
 *  会员审批状态记录获取
 * @constructor jack
 * */
export const auditLog = (user_id) => qspost('/api/Eexamine/auditLog', {user_id})

/*
 *  会员注销
 * @constructor jack
 * */
export const cancellation = (user, desc) => qspost('/api/Eexamine/cancellation', {user, desc})


/*********************通知公告*********************************************/

/**
 *
 * 通知公告列表
 * @constructor jack
 */
export const noticeList = (page, limit) => qspost('/api/notice/queryMember', {page, limit})

/**
 *
 * 通知公告详情
 * @constructor jack
 */
export const noticeDetail = (id) => qspost('/api/notice/noticeDetailMember', {id})


/**
 *
 * 通知公告反馈提交
 * @constructor jack
 */
export const noticeReplyAddMember = (notice_id, content, attached_file) => qspost('/api/notice/noticeReplyAddMember', {
    notice_id,
    content,
    attached_file
})


/**
 *
 * 通知公告详情 -h5
 * @constructor jack
 */
export const noticeDetail2h5 = (notice_id) => qspost('/api/notice/noticeDetail2h5', {notice_id})


/**
 *
 * 通知公告详情 -h5
 * @constructor jack
 */
export const noticeSignInAdd = (notice_id, company_name, tel_name, tel_number) => qspost('/api/notice/noticeSignInAdd', {
    notice_id,
    company_name,
    tel_name,
    tel_number
})

/**
 *
 * 会员增加信息/修改信息
 * @constructor jack
 */
export const addCredit = (
    url = 'add_credit',
    id,
    register_capital, // '注册资本'
    register_years, // '连续经营年限'
    social_security_number, // '社保人数'
    member_years, // '会员年限'
    practice_condition, // '消防技术服务机构从业条件'
    information_qualification, // '信息类相关资质及证书'
    education_and_training, // '教育培训类相关资质及证书'
    lampblack, // '排油烟大气环保相关资质及证书'
    fire_products, // '消防产品相关资质及证书'
    construction_construction, // '建筑、消防施工等相关资质及证书'
    patent_certificate, // '消防行业相关专利证书'
    government_projects, // '政府有关部门认可的示范项目'
    association_project, // '消防相关行业协会认可的示范项目'
    industry_certification, // '获得过本行业相关认证'
    above_related, // '具有非上述类相关资质及证书'
    fire_products_features, // '主营消防产品及特点'
    fire_services_features, // '主营消防服务及特点'
    management_number, // '近三年消防行业业务项目数量'
    business_income, // '近三年消防行业营业收入'
    service_experience_number, // '近三年政府购买服务项目'
    exponent, // '典型项目  0无 1有'
    exponent_file, // '典型项目附件'
    exponent_desc, // '典型项目描述'
    corps_credit, // '总队信用评价 0否 1是'
    corps_credit_file, // '总队信用评价附件'
    corps_credit_desc, // '总队信用评价描述'
    association_credit, // '协会信用评价 0否 1是'
    association_credit_file, // '协会信用评价附件'
    association_credit_desc, // '协会信用评价描述'
    social_credit, // '社会信用评价 0否 1是'
    social_credit_file, // '社会信用评价附件'
    social_credit_desc, // '社会信用评价描述'
    assessment, // '信用评价事件 0否 1是'
    assessment_file, // '信用评价事件附件'
    assessment_desc, // '信用评价事件描述'
    is_legislation, // '是否提出立法方面的意见和建议 0否 1是'
    legislation_file, // '立法方面附件'
    legislation_desc, // '立法方面描述'
    is_policy, // '是否提出政策方面的意见和建议 0否 1是'
    policy_file, // '政策方面附件'
    policy_desc, // '政策方面描述'
    is_standard, // '是否提出标准方面的意见和建议 0否 1是'
    standard_file, // '标准方面附件'
    standard_desc, // '标准方面描述'
    is_market, // '是否提出市场方面的意见和建议 0否 1是'
    market_file, // '市场方面附件'
    market_desc, // '市场方面描述'
    is_investigation, // '是否提出调研方面的意见和建议 0否 1是'
    investigation_file, // '调研方面附件'
    investigation_desc, // '调研方面描述'
    standards, // '是否参与制定国标 0否 1是'
    standards_file, // '制定国标附件'
    standards_desc, // '制定国标描述'
    landmarks, // '是否参与制定地标 0 否 1是'
    landmarks_file, // '制定地标附件'
    landmarks_desc, // '制定地表描述'
    make_group, // '是否参与制定团体 0否 1是'
    make_group_file, // '制定团体附件'
    make_group_desc, // '制定团标描述'
    association_association, // '是否参与制定协会行业服务标准 0否 1是'
    association_association_file, // '行业服务附件'
    association_association_desc, // '行业服务描述'
    scene_check, // '是否参与质量现场核查工作 0否 1是'
    scene_check_file, // '现场核查附件'
    scene_check_desc, // '现场核查描述'
    propaganda_last, // '宣传协会频次 去年 0无 1有'
    propaganda_last_num, // '宣传协会频次 去年次数'
    propaganda_this, // '宣传协会频次 本年 0无 1有'
    propaganda_this_num, // '宣传协会频次 本年次数'
    recommend_last, // '发展会员数量 去年 0无 1有'
    recommend_last_num, // '发展会员数量 去年数量'
    recommend_this, // '发展会员数量 本年 0无 1有'
    recommend_this_num, // '发展会员数量 本年数量'
    contact_member_last, // '联系会员频次 去年 0无 1有'
    contact_member_last_num, // '联系会员频次 去年次数'
    contact_member_this, // '联系会员频次 本年 0无 1有'
    contact_member_this_num, // '联系会员频次 本年次数'
    higher_level, // '上级单位ID'
    level, // '等级'
    lower_level, // '下级单位IDs'
    introduction_unit_ids, // '介绍会员单位入会'
    interactive_information, // '合作会员单位'
    related_information, // '与协会互动信息'
    contact_person,//联络人
    contact_phone,//联络电话
    state,// 1为提交
) => qspost(`/api/Credit/${url}`, {
    id,
    register_capital,
    register_years,
    social_security_number,
    member_years,
    practice_condition,
    information_qualification,
    education_and_training,
    lampblack,
    fire_products,
    construction_construction,
    patent_certificate,
    government_projects,
    association_project,
    industry_certification,
    above_related,
    fire_products_features,
    fire_services_features,
    management_number,
    business_income,
    service_experience_number,
    exponent,
    exponent_file,
    exponent_desc,
    corps_credit,
    corps_credit_file,
    corps_credit_desc,
    association_credit,
    association_credit_file,
    association_credit_desc,
    social_credit,
    social_credit_file,
    social_credit_desc,
    assessment,
    assessment_file,
    assessment_desc,
    is_legislation,
    legislation_file,
    legislation_desc,
    is_policy,
    policy_file,
    policy_desc,
    is_standard,
    standard_file,
    standard_desc,
    is_market,
    market_file,
    market_desc,
    is_investigation,
    investigation_file,
    investigation_desc,
    standards,
    standards_file,
    standards_desc,
    landmarks,
    landmarks_file,
    landmarks_desc,
    make_group,
    make_group_file,
    make_group_desc,
    association_association,
    association_association_file,
    association_association_desc,
    scene_check,
    scene_check_file,
    scene_check_desc,
    propaganda_last,
    propaganda_last_num,
    propaganda_this,
    propaganda_this_num,
    recommend_last,
    recommend_last_num,
    recommend_this,
    recommend_this_num,
    contact_member_last,
    contact_member_last_num,
    contact_member_this,
    contact_member_this_num,
    higher_level,
    level,
    lower_level,
    introduction_unit_ids,
    interactive_information,
    related_information,
    contact_person,
    contact_phone,
    state,
})

/**
 *
 * 会员增加信息/修改信息
 * @constructor jack
 */
export const getCreditInformation = () => qspost('/api/Credit/getCreditInformation', {})

/**
 *
 * 获取一级联络单位
 * @constructor jack
 */
export const getOneLevelCompany = () => qspost('/api/Credit/getTrueContactCompany', {})

/**
 *
 * 查询可介绍会员单位（系统会员）
 * @constructor jack
 */
export const getTruecompany = () => qspost('/api/Credit/getTruecompany', {})

/**
 *
 * 在线支付续费状态
 */
export const getPayStatus = (user_id) => qspost('/api/Eexamine/payStatus', {user_id})

/**
 *
 * 获取订单金额
 */
export const getTotalMoney = (user_id) => qspost('/api/Eexamine/getTotalMoney', {user_id})

/**
 *
 * 创建订单
 */
export const createOrder = (user_id, pay_years) => qspost('/api/order/createOrder', {user_id, pay_years})

/**
 *
 * 获取缴费数据
 */
export const getOrderlist = (user_id, page, limit) => qspost('/api/order/getOrderlist', {user_id, page, limit})

/**
 *
 * 微信订单状态查询
 */
export const checkPayState = (user_id, order_num) => qspost('/api/order/orderQuery', {user_id, order_num})
/**
 *
 * 查询信用标签
 */
export const getInformationLabel = () => qspost('/api/credit/getInformationLabel', {})

/**
 *
 * 查询合作单位（系统会员）
 */
export const getCompany = () => qspost('/api/credit/getcompany', {})

/**
 *
 * 会员添加/编辑反馈留言
 */
export const addFeedback = (id,content) => qspost('/api/Credit/addFeedback', {id,content})

/**
 *
 * 会员/协会删除反馈留言
 */
export const delFeedback = (id) => qspost('/api/Credit/delFeedback', {id})

/**
 *
 * 会员获取反馈留言列表）
 */
export const getFeedBackList = (page,limit) => qspost('/api/Credit/getFeedBackList', {page,limit})

/**
 *
 * 会员获取抽查列表）
 */
export const getCheckLogList = (page,limit) => qspost('/api/Credit/getCheckLogList', {page,limit})

/**
 *
 * 修改注册手机号
 */
export const changePhone = (tel,sms_code) => qspost('/api/User/changePhone', {tel,sms_code})